import {
    defineMessages,
} from 'react-intl'

const messages = defineMessages({
    "last_message_created_at": {
        id: 'messages.listing.filters.date.last_message_created_at',
        defaultMessage: 'Last message received at',
    },
    "last_message_content": {
        id: 'messages.listing.filters.date.last_message_content',
        defaultMessage: 'Last message content',
    },
    "contact_firstname": {
        id: "messages.listing.headers.contact_firstname",
        defaultMessage: "Contact first name",
    },
    "contact_lastname": {
        id: "messages.listing.headers.contact_lastname",
        defaultMessage: "Contact last name",
    },
    "contact_organization_name": {
        id: "messages.listing.headers.contact_organization_name",
        defaultMessage: "Contact organization name",
    },
    "contact_type": {
        id: "messages.listing.headers.contact_type",
        defaultMessage: "Contact type",
    },
    "contact_phonenumber": {
        id: "messages.listing.headers.contact_phonenumber",
        defaultMessage: "Contact phone number",
    },
    "contact_email": {
        id: "messages.listing.headers.contact_email",
        defaultMessage: "Contact email",
    },
    "contact_name": {
        id: "messages.listing.headers.contact_name",
        defaultMessage: "Contact name",
    },
    "contact_id": {
        id: "messages.listing.headers.contact_id",
        defaultMessage: "Contact",
    },
    "most_used_filters": {
        id: "messages.listing.headers.most_used_filters",
        defaultMessage: "Most used filters",
    },
    "contact_related_filters": {
        id: "messages.listing.headers.contact_related_filters",
        defaultMessage: "Contact related filters",
    },
    "status_filter_placeholder": {
        id: "messages.listing.headers.status_filter_placeholder",
        defaultMessage: "Conversation status",
    },
    "status": {
        id: "messages.listing.headers.status",
        defaultMessage: "Conversation status",
    }
})

export const messageTotals = []

export const messageFields = [
    'contact.name',
    'contact.emailKeyword',
    'contact.email',
    'contact.nameAnalyzed',
    'contact.nameKeyword',
    'contact.organizationNameKeyword',
    'contact.organizationNameAnalyzed',
    'lastCustomerMessage.content',
]

export const getMessagesFilters = function (context) {
    return [
        {
            section: context.intl.formatMessage(messages["most_used_filters"]),
        },
        {
            nameId: 'createdAt',
            label: context.intl.formatMessage(messages["last_message_created_at"]),
            filterMatch: 'lastCustomerMessage.createdAt',
            type: 'date',
            initialValue: { startDate: null, endDate: null },
            initialSelect: 'is'
        },
        {
            nameId: 'statuses',
            label: context.intl.formatMessage(messages["status"]),
            type: 'select',
            filterMatch: 'conversationStatus',
            typeOfSelect: 'conversation-status-select',
            placeHolder: context.intl.formatMessage(messages["status_filter_placeholder"]),
            initialValue: [],
            initialSelect: 'isOneOf'
        },
        {
            nameId: 'content',
            label: context.intl.formatMessage(messages["last_message_content"]),
            filterMatch: 'lastCustomerMessage.content',
            type: 'text',
            initialValue: '',
            initialSelect: 'is'
        },
        {
            section: context.intl.formatMessage(messages["contact_related_filters"]),
        },
        {
            nameId: 'contactId',
            label: context.intl.formatMessage(messages["contact_id"]),
            filterMatch: 'contactId',
            type: 'select',
            typeOfSelect: 'customer-select',
            initialValue: "",
            initialSelect: 'isOneOf'
        },
        {
            nameId: 'name',
            label: context.intl.formatMessage(messages["contact_name"]),
            filterMatch: 'contact.name',
            type: 'text',
            initialValue: '',
            initialSelect: 'is'
        },
        {
            nameId: 'firstName',
            label: context.intl.formatMessage(messages["contact_firstname"]),
            filterMatch: 'contact.firstName',
            type: 'text',
            initialValue: '',
            initialSelect: 'is'
        },
        {
            nameId: 'lastName',
            label: context.intl.formatMessage(messages["contact_lastname"]),
            filterMatch: 'contact.lastName',
            type: 'text',
            initialValue: '',
            initialSelect: 'is'
        },
        {
            nameId: 'organizationName',
            label: context.intl.formatMessage(messages["contact_organization_name"]),
            filterMatch: 'contact.organizationNameKeyword',
            type: 'text',
            initialValue: '',
            initialSelect: 'is'
        },
        {
            nameId: 'contactType',
            label: context.intl.formatMessage(messages["contact_type"]),
            filterMatch: 'contact.type',
            type: 'select',
            typeOfSelect: 'contactType-select',
            initialValue: [],
            initialSelect: 'isOneOf'
        },
        {
            nameId: 'phoneNumber',
            label: context.intl.formatMessage(messages["contact_phonenumber"]),
            filterMatch: 'contact.phoneNumberKeyword',
            type: 'text',
            initialValue: '',
            initialSelect: 'is'
        },
        {
            nameId: 'email',
            label: context.intl.formatMessage(messages["contact_email"]),
            filterMatch: 'contact.emailKeyword',
            type: 'text',
            initialValue: '',
            initialSelect: 'is'
        },
    ]
}




// WEBPACK FOOTER //
// ./src/common/search-filter/search/messagesFilters.jsx